import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepTwoExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepTwoExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.climbStepTwoExtraLevels.data.climbStepTwoExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
